/**
 *  HomeBuyersCategories
 */
import React from 'react';

function HomeBuyersCategories() {
  return (
    <div id="category">
      {/* <h1 className="headline txt-en-s mt-xl mb-ll ls-s mv">
        Brand Categories
      </h1>

      <HomeBuyersCategoriesSlick /> */}

      <section>
        <div className="wrapper">
          {/* <div className="txt-box60 cat en ls-s txt-en-ss pt-l mv">
            <span>Beauty</span>
            <span>LifeStyle</span>
            <span>Fragrance</span>
            <span>Bag</span>
            <br className="pcbr" />
            <span>Interior</span>
            <span>Apparel</span>
            <span>Wellness</span>
            <span>Household Goods</span>
            <span>Miscellaneous Goods</span>
            <span>Mens</span>
            <span>Accessory</span>
            <span>Ladies</span>
            <span>Kids / Baby</span>
          </div> */}

          {/* <div className="txt-c mt-ll">
            {referral ? (
              <>
                <a
                  className="btn-common txt jp ls-m"
                  onClick={() => setIsModalOpen(true)}
                >
                  登録ブランドをチェック
                </a>
                <SignUpModal
                  isOpen={isModalOpen}
                  toggle={() => setIsModalOpen((prev) => !prev)}
                  referralBrandId={referralBrandId}
                />
              </>
            ) : (
              <Link className="btn-common txt jp ls-m" to="/registration/buyer">
                登録ブランドをチェック
              </Link>
            )}
          </div> */}
        </div>
      </section>
    </div>
  );
}

export default HomeBuyersCategories;
